module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAf0lEQVR42u3aQQ3AMAwDwFAoiX0GsgxHyf1VGgZfJBO4V6J4kkxzBgAAAAAAAAAAAACAcoB5d5oCAAAAAAAA/PeAtgEAAAAAABfgW0+aAgAAAAAAAAAAAAAAAAAAnMMAAAAA0A7gNwgAAAAAALoLEpqiAAAAAAAAAAAAAAD05ADHdRMOOqa+LwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Costa-Rica.png
// module id = M7cX
// module chunks = 0 62 63